import { ReactNode } from 'react';
import { PRIVACY_DISPLAY_CLASSES } from 'utils/privacyClasses';
import styles from './DisabledGuarantorDetail.module.css';

type TProps = { label: string; value: ReactNode | null };

export const DisabledGuarantorDetail = ({ label, value }: TProps) => {
  if (!value) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.label}>{label}</div>
      <div className={PRIVACY_DISPLAY_CLASSES}>{value}</div>
    </div>
  );
};
